import { navigateTo } from '#imports'

import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import type { ApiSpecs } from '@backmarket/nuxt-module-http-v2/specs'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'

import { isShippable } from '~/scopes/checkout/utils/cart'

import { CHECKOUT } from '../../routes-names'

export function useRedirectIfMissingShippingInformation(currentStep: string) {
  const logger = useLogger()
  const experiments = useExperiments()

  const redirectIfMissingShippingInformation = async (
    addressList: ApiSpecs['/bm/cart']['GET']['response']['addressList'],
    shippableCountries: ApiSpecs['/bm/cart']['GET']['response']['shippableCountries'],
  ) => {
    if (!isShippable(addressList, shippableCountries)) {
      logger.info(`[CHECKOUT][${currentStep}] Cart is not shippable`, {
        shippableCountries,
        shippingCountry: addressList.deliver?.country,
        owners: ['bot-squad-checkout-front'],
      })

      const isSinglePageAddressesEnabled =
        experiments['experiment.checkoutOnePageAddress'] === 'onePageAddress'

      await navigateTo({
        name: isSinglePageAddressesEnabled
          ? CHECKOUT.ADDRESSES
          : CHECKOUT.SHIPPING_ADDRESS,
      })
    }
  }

  return { redirectIfMissingShippingInformation }
}
